<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Пользователи") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">
            {{ $t("message.Пользователи") }}
          </li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">
        {{ $t("message.Добавить_пользователя") }}
      </b-button>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="enabled" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.enabled == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.enabled == false"
          ></i>
        </template>
        <template slot="roles" slot-scope="data">
          <b-badge
            class="mr-1"
            v-for="pack in data.item.roles"
            :key="pack.id"
            >{{ pack.name }}</b-badge
          >
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="modalInfo"
        @hide="resetModal"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Пользователи_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <UserForm :model="UserModel"></UserForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import UserForm from "./UserForm";
import Vue from "vue";

export default {
  name: "Users",
  components: {
    UserForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "username", sortable: true },
        { key: "enabled", sortable: true },
        { key: "static_token", sortable: true },
        { key: "created_at", sortable: true },
        { key: "updated_at", sortable: true },
        { key: "roles", sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      UserModel: {},
      RoleModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "admin:fully_manage").length;
    }
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("users", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.UserModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.UserModel.id > 0) {
        this.$noname
          .patch("users", this.UserModel.id, this.UserModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("users", this.UserModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    },
    resetModal() {
      // this.deviceModel = {}
    },
    addRow() {
      this.UserModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_пользователя?"))
        .then(response => {
          this.$noname
            .delete("users", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "device-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });
              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    resetModal() {
      // this.deviceModel = {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Users.vue